import {Injectable, EventEmitter} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ItemsService} from 'app/commons/items.service';

@Injectable({
    providedIn: 'root'
})
export class AppService{

    public httpEmetteur: EventEmitter<{}>;
    
    constructor(private http: HttpClient) {
    }
    
    async loadForms(){
        return this.http.get<any>(ItemsService.API_URL + 'app/forms')
            .toPromise();
    }

    getProcess(alias:string,formAlias:string){
        return this.http.get<any>(ItemsService.API_URL + 'app/process/'+alias)
            .toPromise();
    }

}
